export const formatPuzzleType = (type: string) => {
  const types: { [key: string]: string } = {
    'FULL_COURSE': 'Full Course',
    'SINGLE_HOLE': 'Single Hole',
    'SECTION': 'Section',
    'FRONT_NINE': 'Front Nine',
    'BACK_NINE': 'Back Nine',
    'LOGO': 'Logo'
  };
  return types[type] || type;
};

export const formatAvailability = (status: string) => {
  const statuses: { [key: string]: string } = {
    'AVAILABLE': 'Available',
    'COMING_SOON': 'Coming Soon',
    'SOLD_OUT': 'Sold Out'
  };
  return statuses[status] || status;
}; 